<template>
    <div class="searchItemTitle">{{ $t('Стадия процедуры') }}</div>
    <div>
        <v-checkbox
            class="procedureStepCheckbox"
            v-for="step in procedureSteps"
            :key="step.code + '_' + step.round"
            v-model="searchParams.steps"
            :label="$t(step.name)"
            :value="step"
            :true-icon="'mdi-check mdi-18px'"
            :false-icon="'voidCheckbox'"
            hide-details
        />
    </div>
</template>

<script>
export default {
    name: 'ProcedureStep',
    props: {
        procedureSteps: {
            type: Array,
            required: true,
            default: []
        },
        searchParams: {
            type: Object,
            required: true,
        },
    },
}
</script>
<style scoped>
:deep(.v-input--density-default) {
    --v-input-control-height: auto;
}
:deep(.v-selection-control--density-default) {
    --v-selection-control-size: 30px;
}
:deep(.procedureStepCheckbox .v-label) {
    color: rgb(var(--black-color));
    font-family: var(--primary-font-family-name);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    opacity: 1;
    padding-left: 13px;
}
:deep(.mdi-check.mdi-18px) {
    border-radius: 3px;
    border: 1px solid rgba(var(--black-color), 0.3);
}
:deep(.voidCheckbox) {
    border-radius: 3px;
    border: 1px solid rgba(var(--black-color), 0.3);
    background-color: rgb(var(--white-color));
}
</style>
